import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, Typography, TextField, InputAdornment } from '@material-ui/core';
import _ from 'lodash';
import ApplicationTableRow from './ApplicationTableRow';
import ApplicationTableHeader from './ApplicationTableHeader';
import ValidationError from './ValidationError';

const PointsField = ({ values, max, sum, input, meta: { error, touched }, groupByDistricts, districts }) => {
  const categoriesEnabled = values.filter(a => a.category !== null).length > 0;
  const subcategoriesEnabled = values.filter(a => a.subcategory !== null).length > 0;

  const renderTable = (applications, categoriesEnabled, subcategoriesEnabled, input) => (
    <Table className="projects-table">
      <ApplicationTableHeader categoriesEnabled={categoriesEnabled} subcategoriesEnabled={subcategoriesEnabled} rightActionLabel="Ilość punktów" />
      <TableBody>
        {applications.map(application => (
          <ApplicationTableRow
            key={application.id}
            application={application}
            categoriesEnabled={categoriesEnabled}
            subcategoriesEnabled={subcategoriesEnabled}
            rightAction={
              <TextField
                onChange={event => {
                  const value = Number.parseInt(event.target.value || 0);
                  if (value && value > 0) {
                    input.onChange([...input.value.filter(i => i.applicationId !== application.id), { applicationId: application.id, value }]);
                  } else {
                    input.onChange([...input.value.filter(i => i.applicationId !== application.id)]);
                  }

                  input.onBlur();
                }}
                value={input.value.some(i => i.applicationId === application.id) ? input.value.find(i => i.applicationId === application.id).value : ''}
                margin="dense"
                style={{ width: 90 }}
                type="number"
                InputProps={{ endAdornment: <InputAdornment position="end">pkt.</InputAdornment> }}
              />
            }
          />)
        )}
      </TableBody>
    </Table>);

    return (
      <React.Fragment>
        <div className="box">
          <div className="col-sm-12">
            <Typography variant="body2" style={{ marginBottom: 30 }}>Rozdysponuj punkty pomiędzy wybrane projekty. Maksymalna ilość punktów do rozdysponowania to <strong>{max}</strong></Typography>
            {groupByDistricts || categoriesEnabled
              ? _(values)
                .groupBy(x => groupByDistricts ? x.district : x.category)
                .map((value, key) => ({ key, applications: value }))
                .sortBy(x => groupByDistricts ? districts.indexOf(x.key) : ['key'])
                .value()
                .map(x => (
                  <div key={x.key} style={{ marginBottom: 30 }}>
                    <h3 className="category"><i className="fa fa-bookmark" /> <span>{groupByDistricts ? 'Obszar' : 'Kategoria'}</span> {x.key}</h3>
                    {renderTable(x.applications, groupByDistricts ? categoriesEnabled : false, subcategoriesEnabled, input)}
                  </div>))
            : renderTable(values, categoriesEnabled, subcategoriesEnabled, input)}
            <Typography variant="body2">Wykorzystałeś {sum}&nbsp;pkt.</Typography>
        </div>
      </div>
      {error && touched ? <ValidationError error={error} /> : null}
    </React.Fragment>);
};

PointsField.propTypes = {
  values: PropTypes.array.isRequired,
  max: PropTypes.number.isRequired,
  sum: PropTypes.number.isRequired,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  groupByDistricts: PropTypes.bool.isRequired,
  districts: PropTypes.array,
};

export default PointsField;



// WEBPACK FOOTER //
// ./src/components/budget/types/PointsField.js